module.exports = __webpack_public_path__ + "media/St 4-Question 15-incorrect.5d8944ca.wav";